// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import styled from 'styled-components';

import { ColorProps, color } from '../../styled/color';
import { TextAlignProps, textAlign } from '../../styled/text';

interface HugeTitleProps {
  weight?: 'Medium' | 'Bold';
}

export default styled.h1<HugeTitleProps & ColorProps & TextAlignProps>`
  font-weight: ${({ weight }) => weight === 'Medium' ? 500 : 700 };
  font-size: 48px;
  line-height: 72px;
  text-align: center;
  letter-spacing: 0.77px;
  ${color}
  ${textAlign}
`;
